import React from "react";
import PageHeader from "../subSkills/pageHeader";
import Table from "./Table";

const SubSkillList = () =>{

    return (
        <>
        <PageHeader />
        <Table />
        </>
    )
};
export default SubSkillList;